import ZoomIcon from './component'

export default ZoomIcon
